import {inject} from 'aurelia-framework';
import Backend from "../backend";
import isMobile from "ismobilejs";
import {UserInfoProvider} from "../util/user-info-provider";
import {Router} from "aurelia-router";
import {ShoppingCart} from "./checkout-flow/shopping-cart";

@inject(Backend, Router, UserInfoProvider, ShoppingCart)
export class GoB {
  showGrid = false
  router;
  backend;
  userInfoProvider;
  shoppingCart;

  iconKey = 'bread';
  crateChoiceModalComponentRef;

  constructor(backend, router, userInfoProvider, shoppingCart) {
    this.router = router;
    this.backend = backend;
    this.userInfoProvider = userInfoProvider;
    this.shoppingCart = shoppingCart;
    this.isMobile = isMobile().phone;
  }

  activate(params) {
    this.hasActiveSubscription = Boolean(this.userInfoProvider.getInfo().subscriptionId);

    return Promise.all([
      this.shoppingCart.load()
        .then(() => {
          this.shoppingCartHasCrateProduct = this.shoppingCart.hasCrateProduct();
        }),
      this.backend.CrateCatalogQueryHandler_handleV2({onlyFeatured1: true})
        .then(result => this.products = result.items),
      this.backend.CmsFragmentPublicQueryHandler_handle({items: [
            {cmsFragmentKey: "home_gob__section1_image"},
            {cmsFragmentKey: "home_gob__section1_html"},

            {cmsFragmentKey: "home_gob__section2_header_html"},
            {cmsFragmentKey: "home_gob__section2_1_html"},
            {cmsFragmentKey: "home_gob__section2_2_html"},
            {cmsFragmentKey: "home_gob__section2_3_html"},

            {cmsFragmentKey: "home_gob__section3_header_html"},

            {cmsFragmentKey: "home_gob__section4_header_html"},
            {cmsFragmentKey: "home_gob__section4_1_image"},
            {cmsFragmentKey: "home_gob__section4_1_html"},
            {cmsFragmentKey: "home_gob__section4_2_image"},
            {cmsFragmentKey: "home_gob__section4_2_html"},
            {cmsFragmentKey: "home_gob__section4_3_image"},
            {cmsFragmentKey: "home_gob__section4_3_html"},

            // home_gob_section_5 == home__section_8 (Same as From home.html)
            {cmsFragmentKey: "home__section8_image", imgWidth: 750},
            {cmsFragmentKey: "home__section8_html"},

            {cmsFragmentKey: "home_gob__section6_header_html"},
            {cmsFragmentKey: "home_gob__section6_1_image"},
            {cmsFragmentKey: "home_gob__section6_1_html"},
            {cmsFragmentKey: "home_gob__section6_2_image"},
            {cmsFragmentKey: "home_gob__section6_2_html"},
            {cmsFragmentKey: "home_gob__section6_3_image"},
            {cmsFragmentKey: "home_gob__section6_3_html"},

            {cmsFragmentKey: "home_gob__section7_header_html"},
            {cmsFragmentKey: "home_gob__section7_1_html"},
            {cmsFragmentKey: "home_gob__section7_2_html"},
            {cmsFragmentKey: "home_gob__section7_3_html"},
            {cmsFragmentKey: "home_gob__section7_5_html"},

            {cmsFragmentKey: "home_gob__section8_image"},
            {cmsFragmentKey: "home_gob__section8_html"},

            {cmsFragmentKey: "home_gob__section9_image"},
            {cmsFragmentKey: "home_gob__section9_html"},
          ]})
        .then(result => {
          this.cmsFragments = result;
        }),
    ]);
  }
}
